module.exports = __webpack_public_path__ + "static/media/rocketBottom.c9c635e4.png";